import React from 'react';
import { toSentTime, toSentDay } from '../../../helpers/index';

import styles from './legacy_conversation_room.module.css';

export default function ConversationsListItem({ selectedConversation, conversation }) {
  const hasUnreadMessages = conversation.unread_messages > 0;
  const imageUrl = conversation.other_user_conversations[0]?.profile?.photo || '';

  return (
    <>
      <div className={`${styles.message_in_list} ${conversation.uuid === selectedConversation ? styles.selected : ''}`}>
        <div className='container'>
          <div className='row'>
            <div className='col-2 my-auto de-pad'>
              <div className={styles.chat_room_pp_avatar} style={{ backgroundImage: `url("${imageUrl}")` }} />
            </div>
            <div className='col-10 my-auto'>
              <div className='row' style={{ maxWidth: '107%' }}>
                <div className='col my-auto marg-bottom-0'>
                  <p className={`bold ${styles.chat_room_pp_info}`}>
                    {conversation.other_user_conversations[0].profile.display_name}
                  </p>
                </div>
                <div className={styles.message_time_date}>
                  {conversation.messages[0] && (
                    <>
                      <div className={styles.message_time_date_side_fade}></div>
                      <p className={styles.chat_room_pp_created_at}>
                        {toSentDay(conversation.messages[conversation.messages.length - 1].created_at)}{' '}
                        {toSentTime(conversation.messages[conversation.messages.length - 1].created_at)}
                      </p>
                    </>
                  )}
                </div>
              </div>
              {conversation.messages.length > 0 && (
                <div className={styles.chat_room_message_wrap}>
                  <p
                    style={{ width: hasUnreadMessages ? 'calc(100% - 10px)' : '100%' }}
                    className={styles.chat_room_last_message}
                  >
                    {conversation.messages[conversation.messages.length - 1].body}
                  </p>
                  {hasUnreadMessages && <div className={styles.new_messages_dot}></div>}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
